import React, { useCallback, useMemo, useState } from 'react';
import SelectCustomers from '@components/SelectCustomers';
import { useTranslation } from 'react-i18next';
import { IDeviceActionRequestPayload } from '../types';

interface SyncApnProps {
  uploadedDevices: any;
  actionKey: number;
  handleDeviceActions: (item: IDeviceActionRequestPayload) => void;
}

const useSyncApn = ({
  actionKey,
  uploadedDevices,
  handleDeviceActions,
}: SyncApnProps) => {
  const { t } = useTranslation(['device-actions-modal']);

  const [selectedCustomerId, setSelectedCustomerId] = useState();

  const contentSteps = useMemo(
    () => [
      {
        title: t('steps.client.name'),
        content: (
          <SelectCustomers
            value={selectedCustomerId}
            onChange={setSelectedCustomerId}
          />
        ),
      },
    ],
    [selectedCustomerId, t],
  );

  const onSubmit = useCallback(async () => {
    const payload: IDeviceActionRequestPayload = {};
    payload.action = actionKey;
    payload.processData = selectedCustomerId;

    payload.devices = uploadedDevices;
    return handleDeviceActions(payload);
  }, [actionKey, selectedCustomerId, uploadedDevices, handleDeviceActions]);

  const reinitState = () => {
    setSelectedCustomerId(undefined);
  };

  const syncApnData = {
    contentSteps,
    onSubmit,
    reinitState,
  };

  return { syncApnData };
};

export default useSyncApn;
